import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { AuthLayout } from "../components/AuthLayout";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const { error: err } = await signIn({ email, password });
    setLoading(false);
    if (err) { setError(err.message); toast.error(err.message); return; }
    toast.success("Welcome, admin.");
    const requested = location.state?.from;
    const destination = typeof requested === "string" && requested.startsWith("/admin") ? requested : "/admin";
    navigate(destination, { replace: true });
  };

  return (
    <AuthLayout eyebrow="SimplyRefer Admin" title="Admin sign in" subtitle="Verify AHPRA registrations and manage trials." testId="admin-login-page">
      <div className="mb-5 flex items-start gap-3 rounded-md border border-slate-200 bg-slate-50 p-3">
        <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-primary" />
        <p className="text-sm text-slate-600">Restricted to SimplyRefer staff.</p>
      </div>
      <form onSubmit={handleSubmit} className="space-y-5" data-testid="admin-login-form">
        <div className="space-y-2"><Label htmlFor="email">Email</Label><Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter your admin email" data-testid="admin-login-email" /></div>
        <div className="space-y-2"><Label htmlFor="password">Password</Label><Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter your password" data-testid="admin-login-password" /></div>
        {error && <p className="text-sm text-destructive" data-testid="admin-login-error">{error}</p>}
        <Button type="submit" className="w-full" disabled={loading} data-testid="admin-login-submit">
          {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Sign in
        </Button>
      </form>
    </AuthLayout>
  );
}
